module.exports = __webpack_public_path__ + "img/backyard-planter.96fa1cc8.jpg";